<template>
    <div
      class="flex flex-col justify-between bg-white p-2 border 2xl:gap-8 gap-4"
    >
      <h2 class="text-xs text-primary-900">
        {{ title }}
      </h2>
      <h2 class="text-xl 2xl:text-2xl text-primary-900 text-center">
        {{ (value ?? 0) + " " + (unit ?? "") }}
      </h2>
      <ColorGauge
        v-if="value !== null"
        :value="valueAsPercentage ?? value"
        :warning="maxWarningValue"
        :critical="maxDangerValue"
        :flipped="flipped"
      />
      <div v-else></div>
    </div>
  </template>
  
  <script>
  import ColorGauge from "@/components/LinearGauge.vue";
  
  export default {
    components: {
      ColorGauge,
    },
    props: ["value", "valueAsPercentage", "maxWarningValue", "maxDangerValue", "title", "unit", "flipped"],
  };
  </script>